import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
import { TimerIcon } from 'lucide-react';
interface CountdownTimerProps {
  variant?: 'bar' | 'section' | 'inline';
}
export function CountdownTimer({
  variant = 'inline'
}: CountdownTimerProps) {
  const {
    formatted
  } = useCountdown();
  if (variant === 'bar') {
    return <div className="flex items-center gap-2 font-bold text-white bg-red-700 px-3 py-1 rounded-md animate-pulse-fast" data-id="element-36">
        <TimerIcon className="w-4 h-4" data-id="element-37" />
        <span className="tabular-nums" data-id="element-38">{formatted}</span>
      </div>;
  }
  if (variant === 'section') {
    return <div className="flex flex-col items-center justify-center space-y-2" data-id="element-39">
        <div className="flex items-center gap-4 text-5xl md:text-7xl font-bold text-red-500 tabular-nums tracking-wider drop-shadow-[0_0_15px_rgba(239,68,68,0.5)]" data-id="element-40">
          {formatted}
        </div>
      </div>;
  }
  return <span className="inline-flex items-center gap-1 font-bold text-red-500 tabular-nums bg-red-500/10 px-2 py-0.5 rounded" data-id="element-41">
      <TimerIcon className="w-4 h-4" data-id="element-42" />
      {formatted}
    </span>;
}